<script>
import { h } from '@vue/composition-api'
import icons from '../assets/svg/icons.json'

/**
 * SVG default attrs
 *
 * "xmlns": "http://www.w3.org/2000/svg",
 * "width": 19,
 * "height": 19,
 * "viewBox": "0 0 19 19",
 * "fill": "none",
 * "stroke": "currentColor",
 * "stroke-width": 2,
 * "stroke-linecap": "round",
 * "stroke-linejoin": "round"
 *
 */

export default {
  name: 'AgIcon',
  props: {
    fill: {
      type: String,
      default: 'none',
    },
    size: {
      type: [String, Number],
      default: 19,
    },
    stroke: {
      type: String,
      default: 'currentColor',
    },
    strokeLinecap: {
      type: String,
      default: 'round',
    },
    strokeLinejoin: {
      type: String,
      default: 'round',
    },
    strokeWidth: {
      type: [String, Number],
      default: 2,
    },
    icon: {
      type: String,
      default: 'default',
    },
  },
  render(h,){
    const icon = icons[this.icon]

    return h(
      'svg',
      {
        class: 'inline-block',
        attrs: {
          ...icon.attrs,
          fill: this.fill,
          height: this.size,
          width: this.size,
          stroke: this.stroke,
          'stroke-linecap': this.strokeLinecap,
          'stroke-linejoin': this.strokeLinejoin,
          'stroke-width': this.strokeWidth,
        },
        domProps: {
          innerHTML: icon.content,
        },
      },
    )
  },

  // setup(props) {
  //   // eslint-disable-next-line prefer-template
  //   const icon = icons[props.icon]

  //   return () => h(
  //     'svg',
  //     {
  //       class: 'inline-block',
  //       attrs: {
  //         ...icon.attrs,
  //         fill: props.fill,
  //         height: props.size,
  //         width: props.size,
  //         stroke: props.stroke,
  //         'stroke-linecap': props.strokeLinecap,
  //         'stroke-linejoin': props.strokeLinejoin,
  //         'stroke-width': props.strokeWidth,
  //       },
  //       domProps: {
  //         innerHTML: icon.content,
  //       },
  //     },
  //   )
  // },
}
</script>
